import StudentCommentSection from "Pages/StudentPortfolio/StudentCommentSection/StudentCommentSection";
import StudentPerformanceSection from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentPerformanceSection";
import { useState } from "react";
import { Col, Row } from "reactstrap";
// import PerformanceSearchBar from "utilFunctions/shared/PerformanceSearchBar";

const StudentPortfolioMainDestop = ({
  tabs,
  selectedStudent,
  commentsObj,
  setCommentsObj,
  isPerformanceVisible,
}: any) => {
  const [viewAllComments, setViewAllComments] = useState<boolean>(false);

  return (
    <Row className="studentRow">
      {!viewAllComments && (
        <Col
          xxl="8"
          xl="8"
          lg="8"
          md="6"
          sm="12"
          xs="12"
          className="mainDesktopDiv h-100 pr-0"
        >
          <StudentPerformanceSection
            selectedStudent={selectedStudent}
            tabs={tabs}
          />
        </Col>
      )}
      {viewAllComments ? (
        <Col xxl="12" xl="12" lg="12" md="6" sm="12" xs="12">
          <StudentCommentSection
            commentsObj={commentsObj}
            setCommentsObj={setCommentsObj}
            viewAllComments={viewAllComments}
            setViewAllComments={setViewAllComments}
          />
        </Col>
      ) : (
        <Col xxl="4" xl="4" lg="4" md="6" sm="12" xs="12" className="h-100">
          {/* {!isPerformanceVisible && (
            <div style={{ height: "100px", marginBottom: "16px" }}>
              <PerformanceSearchBar
                isPerformanceVisible={isPerformanceVisible}
                setIsPerformanceVisible={setIsPerformanceVisible}
                viewAllComments={viewAllComments}
                mode="miniPerformance"
              ></PerformanceSearchBar>
            </div>
          )} */}
          <StudentCommentSection
            isPerformanceVisible={isPerformanceVisible}
            commentsObj={commentsObj}
            setCommentsObj={setCommentsObj}
            viewAllComments={viewAllComments}
            setViewAllComments={setViewAllComments}
          />
        </Col>
      )}
    </Row>
  );
};
export default StudentPortfolioMainDestop;
